import { Rule } from 'antd/lib/form';
import React, { useMemo } from 'react';
import { TApkType, TParametersOfApkType } from 'types';
import { apkTypes, extraApkTypes } from 'appConstants';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { useTranslation } from 'react-i18next';

interface IApkTypeSelect {
	setIDApkType: (value: Nullable<TApkType>) => void;
	parameterOfApkType: Nullable<TParametersOfApkType>;
}

const ApkTypeSelect: React.FC<IApkTypeSelect> = ({ setIDApkType, parameterOfApkType }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectApplicationApkType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		if (parameterOfApkType === 'main') {
			return apkTypes.map((el) => ({ id: el.apkTypeID, name: el.apkTypeName }));
		}
		if (parameterOfApkType === 'extra') {
			return extraApkTypes.map((el) => ({ id: el.apkTypeID, name: el.apkTypeName }));
		}
		return [];
	}, [parameterOfApkType]);

	return (
		<FormSelect
			testId="ApkTypeSelect"
			name="IDSelectedApkType"
			label="applicationApkTypeLabel"
			options={mappedOptions}
			onChange={setIDApkType}
			validationRules={validationRules}
			disabled={!parameterOfApkType}
		/>
	);
};

export default React.memo(ApkTypeSelect);
